import * as types from "../../../actions/actionTypes"
const initialData = {
  data: { data: [] },
  routes: []
};
const initialState = {
  loading:true,
  error:false,
  data: initialData
};

const PettyCashierOverallCostDetail = (state = initialState, action) => {
  switch (action.type) {
    case types.PETTY_CASHIER_REMOVE_OVERALL_COST_DETAIL_REQUEST:
      return {...state, loading:true };
    case types.PETTY_CASHIER_REMOVE_OVERALL_COST_DETAIL_SUCCESS:
      return {...state, loading:false, data: action.payLoad};
    case types.PETTY_CASHIER_REMOVE_OVERALL_COST_DETAIL_FAILURE:
      return { ...state, loading : false};

    case types.PETTY_CASHIER_GET_OVERALL_COST_DETAIL_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.PETTY_CASHIER_GET_OVERALL_COST_DETAIL_SUCCESS:
      return { ...state, loading:false, data:action.payLoad };
    case types.PETTY_CASHIER_GET_OVERALL_COST_DETAIL_FAILURE:
      return { ...state, loading:false, error: action.error  };
    default:
      return state;
  }
};

export default PettyCashierOverallCostDetail;